import * as React from 'react'
import { FunctionComponent } from 'react'
import TableContext, {
  createTableContext,
} from '../../../../contexts/TableContext'
import { ReportGroupBy } from '../../../../typings/report'
import SalesTable from './SalesTable'

type SalesSorts =
  | 'clickDate'
  | 'processDate'
  | 'productName'
  | 'advertiserName'
  | 'subtracking'
  | 'commission'
  | 'isCrossSale'

type GroupBy = { [key in ReportGroupBy]: string }

interface SalesFilters extends GroupBy {
  groupBy: string
  dateType: string
  startDate: string
  endDate: string
}

export const SalesTableContext = createTableContext<SalesFilters, SalesSorts>()

const SalesReport: FunctionComponent = () => {
  return (
    <TableContext<SalesFilters, SalesSorts>
      Context={SalesTableContext}
      queryParams={[
        'dateType',
        'endDate',
        'startDate',
        'productType',
        'product',
        'category',
        'advertiser',
        'subtracking',
      ]}
    >
      <SalesTable />
    </TableContext>
  )
}

export default SalesReport
